@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.user-limit-description {
  line-height: 24px;
  color: var(--grey-600);
}

.active-user-heading {
  margin: @space-16 0 10px 0;
}

.row-deactivated {
  background-color: @settings-page--subscription-row--deactivated--background-color;
}

.active-user-grid {
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  table-layout: fixed;

  tr {
    border: 1px solid var(--default--border-color--6);
  }

  th {
    padding: @space-16 @space-8;
    text-align: left;
    background: var(--default--background-color--4);
  }

  td {
    font-size: 14px;
    line-height: 24px;
    padding: @space-16 @space-8;
  }

  td:last-child {
    text-align: right;
  }

  th:nth-child(1),
  td:nth-child(1) {
    width: 45%;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 20%;
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 10%;
  }

  th:nth-child(4),
  td:nth-child(4) {
    width: 25%;
  }
}
